





















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ContactListModule } from '@/store/modules/contactList';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ListUtils from '@/lib/listUtils';


@Component({
    name: 'ContactListSearchCriteria'
})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  public locationSearch: any = null;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (AgencySettingsModule.positions.length === 0) {
        await AgencySettingsModule.getPositions();
      }
      if (AgencySettingsModule.locationTypes.length === 0) {
        await AgencySettingsModule.getLocationTypes();
      }
      await ContactListModule.getWorkersForSearchOptions();
    }
  }

  get searchVM() {
      return ContactListModule.contactSearchViewModel;
  }

  get distanceOptions() {
    return ListUtils.distanceOptions()
  }

  get statusOptions() {
    return ListUtils.contactStatuses();
  }

  get positions() {
    return AgencySettingsModule.positions;
  }

  get locationTypes() {
    return AgencySettingsModule.locationTypes;
  }

  get loading() {
    return ContactListModule.loading;
  }

  async search() {
    this.dialog = false;
    await ContactListModule.searchContacts()
  }
}
